import React, { FC } from 'react';
import { TypeBorderFields } from '@/core/generated-types';
import classNames from 'classnames';

const Border: FC<TypeBorderFields> = ({ height, media, repeat, margin }) => {
  return (
    <div
      style={{ height, margin: `${margin}px 0` }}
      className="relative z-10 overflow-visible"
      data-testid="border-img-container"
    >
      <div
        style={{
          height,
          backgroundImage: `url(${media.fields.Image.fields.file.url})`,
        }}
        data-testid="border-img"
        className={classNames(
          'absolute top-1/2 w-full -translate-y-1/2 transform bg-[length:auto_100%] bg-center',
          {
            'bg-no-repeat': !repeat,
            'bg-repeat-x': repeat,
            'bg-contain': repeat,
          },
        )}
      ></div>
    </div>
  );
};

export default React.memo(Border);
